import { jsx as _jsx } from "react/jsx-runtime";
import { useLocale } from 'pe-core-frontend';
import ReactTimeAgo from 'react-time-ago';
export const TimeAgo = ({ date }) => {
    const { intl } = useLocale();
    const tzDate = new Date(`${date}Z`);
    return _jsx(ReactTimeAgo, { date: tzDate, locale: intl.locale, timeStyle: 'rounded' });
};
